var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderborder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 678,
    viewBox: "0 0 1440 678",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_438_780)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 367,
    width: 447,
    height: 61,
    fill: "#610C7D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.5,
    cy: 425,
    rx: 223.5,
    ry: 56,
    fill: "#610C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-329.086 356.4C-386.633 363.874 -432.85 389.737 -491.369 373.928C-540.227 360.726 -581.068 329.173 -599.622 291.706C-627.981 234.43 -611.611 168.438 -574.743 114.189C-558.805 90.7748 -531.286 66.024 -497.778 70.5369C-476.463 73.4054 -460.765 87.5887 -449.868 102.136C-425.169 135.109 -404.143 163.13 -349.248 164.569C-316.196 165.429 -284.092 156.73 -253.033 147.891C-221.973 139.052 -190.253 129.821 -157.189 129.55C-24.9096 128.504 25.7603 242.877 77.2704 316.942C125.12 385.757 199.469 467.998 303.773 473.118C395.212 477.612 494.596 417.151 553.403 368.051C619.735 312.532 688.455 252.472 764.112 203.326C947.566 84.2064 1041.34 254.313 1194.96 303.525C1285.11 332.387 1350.9 306.029 1404.2 244.783C1448.21 194.207 1478.28 133.764 1541.13 97.2031C1584.34 72.0693 1658.41 66.7809 1682.41 104.388C1702.65 136.1 1672.42 172.455 1643.77 199.953C1590.07 251.463 1535.88 303.385 1469.75 345.225C1403.62 387.065 1323.83 418.636 1238.8 422.775C1072.7 430.876 906.605 335.629 749.314 377.927C672.769 398.482 616.314 448.003 556.547 490.525C496.78 533.047 421.567 572.177 341.302 563.88C262.392 555.714 204.306 505.016 142.354 466.092C9.4624 382.599 -160.67 334.48 -329.086 356.4Z",
    fill: "url(#paint0_linear_438_780)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_780",
    x1: 539.433,
    y1: 145.705,
    x2: 522.876,
    y2: 580.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8700A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#980089"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_438_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 677.49,
    fill: "white",
    transform: "translate(-240)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderborder);
export default __webpack_public_path__ + "static/media/header.border.14f2f19ebae9ab76f9e95d42819d93e4.svg";
export { ForwardRef as ReactComponent };